// import React from "react";
import { Button, /*Form, Input*/ } from "antd";
import Logo from "assets/new-hire-logo.png";
import { useNavigate } from "react-router-dom";
import { storage } from "utils/storage";
import { RoleTypes } from "enum/role-type-enum";
// import { FacebookOutlined, TwitterOutlined, LinkedinOutlined } from "@ant-design/icons";




const Footer = () => {
  const navigate = useNavigate();
  const user = storage?.getUserFromStorage();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer ">
      <div className="max-w-6xl mx-auto ">
        <div className="flex flex-col md:flex-row justify-between py-2 md:py-2 ">
          {/* Left Section */}
          <div className=" md:w-[50%] w-[50%]  mb-8 md:mb-0 ">
            <div>
              <img alt="Logo" src={Logo} width={300} className="w-48 md:w-64" />
            </div>

 
           
          </div>

          {/* Right Section */}
          <div className="flex sm:flex-col md:flex-row mt-5 md:mt-5 md:w-[37%] px-3 md:justify-between justify-between my-auto overflo ">
              <div  >
              <ul className=" flex mt-5 md:space-x-8 space-x-5  text-[#637381] md:mx-14  md:font-medium ">
                <li key="home" onClick={() => { navigate("/");  }} className="cursor-pointer hover:text-gray-900">Home</li>
                <li key="about" onClick={() => { navigate("about");  }} className="cursor-pointer hover:text-gray-900">About</li>           
                {user?.role === RoleTypes.ENUMERATOR && (
                  <li key="upload-cv" onClick={() => navigate("/enumerator/profile/cv")} className="cursor-pointer hover:text-gray-900">Upload CV</li>
                )}
              </ul>
              </div>
              <div >
                <Button className="md:px-5 md:py-8 py-6 px-4 md:text-4xl text-2xl bg-[#16a34a] text-white font-normal hover:shadow-lg"
                onClick={() => { scrollToTop();  }}>
                ↑
                </Button>
              </div>           

          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-200 md:py-8 md:pe-0 py-5 pe-5">
          <div className="flex flex-row md:flex-row md:justify-end sm:text-md justify-end md:space-x-10 space-x-10  md:text-left ">
            <a href="/terms-conditions" className="text-md font-medium text-[#637381] hover:text-gray-900">Terms & Conditions</a>
            {/* <a href="/privacy-policy" className="text-md font-medium text-[#637381] hover:text-gray-900">Privacy Policy</a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;